<h1 mat-dialog-title>
  {{ dialogTitle }}
</h1>
<form #form="ngForm" [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.name" />
        <mat-error [control]="addEditForm.controls.name"></mat-error>
      </mat-form-field>

      <mat-dropdown
        [configurationInput]="widgetRequestDropdownSettings()"
        [options]="widgetRequestDropdownOptions()"
        [formControl]="addEditForm.controls.widgetRequestId"
        [isFormSubmitted]="form.submitted || pathOptionsStatus() === ELoadStatus.failure"
      >
      </mat-dropdown>

      <div class="col-12 mt-2 mb-3">
        <button
          mat-stroked-button
          type="button"
          [disabled]="pathOptionsStatus() !== ELoadStatus.success"
          (click)="openEndpointPreview()"
        >
          <mat-icon>visibility</mat-icon>
          {{ 'button.endpointPreview' | translate }}
        </button>
      </div>

      <div class="col-12">
        <app-datatable
          [configurationInput]="{
            areCheckboxesEnabled: false,
            isClientSide: true,
            isDraggable: true,
            isHeaderRowEnabled: false,
            isLoaderEnabled: false,
            isPaginationEnabled: false,
            isSearchEnabled: false,
          }"
          [rowData]="orderedWidgetRequestMapRows()"
          [columns]="widgetRequestMapDatatableColumns"
          [total]="10000"
          [customColumnDef]="[
            { name: 'widgetRequestContentPath', template: pathDropdown, isSortable: false },
            { name: 'columnNameOnWidget', template: nameInput, isSortable: false },
            { name: 'delete', template: rowDelete, isSortable: false },
          ]"
          (rowOrderChange)="widgetRequestMapRowOrders.set($event)"
        />
        <div class="mt-2 mb-3">
          <button
            mat-stroked-button
            [disabled]="pathOptionsStatus() === ELoadStatus.failure"
            (click)="addFieldOption()"
            type="button"
          >
            <mat-icon>add</mat-icon>
            {{ 'button.addContext' | translate: { context: ('field.column' | translate) } }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ submitButtonText }}
    </button>
  </mat-dialog-actions>
</form>

<ng-template #pathDropdown let-row="row">
  @let isErrorShown =
    (!row.widgetRequestContentPath.pristine || isFormSubmitted()) && row.widgetRequestContentPath.errors;
  <div [class]="isErrorShown ? 'path-dropdown-with-error' : 'my-2'">
    <mat-dropdown
      class="path-dropdown"
      [isFormSubmitted]="isFormSubmitted()"
      [options]="pathOptionsOfSelectedResource()"
      [isLoading]="pathOptionsStatus() === ELoadStatus.loading"
      [configurationInput]="{
        enableSearchFilter: true,
        isClientSide: true,
        repositionDropdownList: true,
        singleSelection: true,
        hasMatError: isErrorShown,
        hint: row.exampleHint(),
        text: 'field.requestResponseField' | translate,
      }"
      [formControl]="row.widgetRequestContentPath"
    ></mat-dropdown>
  </div>
</ng-template>

<ng-template #nameInput let-row="row">
  <mat-form-field class="column-name-input" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'field.columnName' | translate }}</mat-label>
    <input matInput [formControl]="row.columnNameOnWidget" />
    <mat-error [control]="row.columnNameOnWidget"></mat-error>
  </mat-form-field>
</ng-template>

<ng-template #rowDelete let-row="row">
  <button
    mat-mini-fab
    type="button"
    class="v-middle"
    (click)="deleteMapRow(row.id)"
    [disabled]="orderedWidgetRequestMapRows().length < 2"
    [matTooltip]="'button.remove' | translate"
  >
    <mat-icon>delete</mat-icon>
  </button>
</ng-template>
